import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import {
  FluentProvider,
  PartialTheme,
  Switch,
  SwitchProps,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";

interface SwitchCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
}

const SwitchCustom = (props: SwitchCustomProps & SwitchProps) => {
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles
  );
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  return isCanBeVisible ? (
    props.theme ? (
      <FluentProvider
        theme={
          props.theme === "dark"
            ? webDarkTheme
            : {
                ...renderTheme,
                colorBrandBackground: "rgb(70, 101, 136)",
                colorBrandBackgroundHover: "rgb(21, 51, 89)",
                colorNeutralForeground2BrandHover: "rgb(21, 51, 89)",
                colorCompoundBrandBackground: "rgb(70, 101, 136)",
                colorCompoundBrandBackgroundHover: "rgb(21, 51, 89)",
              }
        }
      >
        <Switch {...props} />
      </FluentProvider>
    ) : (
      <Switch {...props} />
    )
  ) : null;
};

export default SwitchCustom;
